import { render } from "./OptionsFounded.vue?vue&type=template&id=0378b530"
import script from "./OptionsFounded.vue?vue&type=script&lang=js"
export * from "./OptionsFounded.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__